import React from "react";
import { Grid } from "@material-ui/core";
import ChangePasswordForm, { IPasswordForm } from "@src/Components/Common/ChangePasswordForm/ChangePasswordForm";
import { Values } from "@src/Tools/Values";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { FormikActions } from "formik";
import { STFormWrapper } from "./styles";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import STPageHeader from "@src/Components/Ui/STPageHeader";

interface IProps {
  auth?: IAuthStore;
}

@inject("auth")
@observer
export default class ChangePassword extends React.Component<IProps> {
  componentDidMount() {
    document.title = Values.getLocalizationValue("changePassword");
  }
  handleSubmit = async (values: IPasswordForm, actions: FormikActions<IPasswordForm>) => {
    await this.props.auth.changeProfilePassword(values.password);
    actions.resetForm();
  };

  render() {
    return (
      <Grid container justify="center" alignItems="center">
        <STFormWrapper>
          <ChangePasswordForm title={Values.getLocalizationValue("createNewPassword")} onSubmit={this.handleSubmit}>
            <Grid container justify="center">
              <STButtonMargin
                variant="contained"
                color="primary"
                type="submit"
                style={{ textTransform: "none", backgroundColor: "green" }}
              >
                {Values.getLocalizationValue("saveNewPassword")}
              </STButtonMargin>
            </Grid>
          </ChangePasswordForm>
        </STFormWrapper>
      </Grid>
    );
  }
}
